import React, { useState, useEffect, forwardRef } from "react";
import {
  Form,
  Spin,
  Button,
  Tooltip,
  Select,
  Popconfirm,
  notification,
} from "antd";
import { useDispatch } from "react-redux";
import SectionHeader from "../../components/global/SectionHeader";
import { API_URL } from "../../environment";
import { ALLLEAVES_DATA } from "../../redux/Store/constants";
import { PlusSquareOutlined } from "@ant-design/icons";
import { useNavigate, Link } from "react-router-dom";
import MaterialTable from "material-table";
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import { useSidebar } from "../../components/provider/Provider";
import moment from "moment";
import Layout from "../../components/global/layout";
import ApiClient from "../../methods/api/apiClient";

const EmployeeAssigned = (props) => {
  const Email = localStorage.getItem("Email");
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [reason, setReason] = useState(false);
  const [array, setArray] = useState([]);
  const [projects, setProjectArray] = useState([]);
  const [memberarray, setmemberarray] = useState([]);
  const [arrayTeam, setArrayTeam] = useState([]);
  const [id, setId] = useState("");

  console.log(memberarray,'==memberarray');  
  console.log(arrayTeam,'==arrayTeam');  

  useEffect(() => {
    userAssignedList();
    ProjectList();

    EployeeList();
  }, []);

  const setReasonModal = () => {
    setReason(false);
    form.resetFields();
    employeechange([])
  };
  const EployeeList = async () => {
    let data = {
      sortBy: "asc",
      count: 1000,
      page:1,
      isDeleted: false,
    };
    ApiClient.allApi("users", data).then((res) => {
      if (res.success) {
        const arrayData = res.data;
        const newarraydata = arrayData.filter((item) => {
          return item.role != "HR" && item.role != "subadmin";
        });
        setArrayTeam(newarraydata);
      }
    });

    setLoading(false);
  };
  const ProjectList = async () => {
    let data = {
      sortBy: "asc",
      count: 1000,
    };
    ApiClient.allApi("projects", data).then((res) => {
      if (res.success) {
        const listing = res.data;
        const newlisting = listing.filter((item) => {
          return item.role != "HR";
        });
        setProjectArray(newlisting);
      }
    });

    setLoading(false);
  };
  const userAssignedList = () => {
    setLoading(true);
    ApiClient.allApi("getAllProjectMembers", {}).then((res) => {
      if (res.success) {
        setLoading(false);
        setArray(res.data);
      } else {
        setLoading(false);
      }
    });
  };

  const handleSubmit = (e) => {
    const ids = memberarray.map((item) => item.split(",")[0]);
    console.log(ids,"jkjkjkj");

    console.log(id);

    let data = {
      id: id,
      memberId: ids.join(","),
    };
    console.log(data);

    ApiClient.allApi("project/add/member", data).then((res) => {
      if (res.success) {
        userAssignedList();
        setReasonModal();
        notification.success({
          message: "Project Assigned Successfully.",
        });
      } else {
        notification.error({
          message: res.error.message,
        });
      }
    });
  };

  async function handleChange1(value) {
    const id = value.split(",");
    setId(`${id[0]}`);

    ApiClient.allApi('getProjectMembers?id='+`${id[0]}`).then((res)=>{
   if(res.success){

    if( res?.data?.members.length){
      const options = res.data.members.map(item=>{
        const value = `${item?.id},${item?.fullName}`
        return value
      })
      console.log(options);
      console.log(options,"hkjhjh")
      setmemberarray(options)
      employeechange(options)
      
  //  setmemberarray(options)
  //     console.log(options);
   

    }
 



 
   } else{
   }
    })

  }
  const employeechange = (event) => {
    setmemberarray(event);
  };

  const columns = [
    {
      title: "Project Name",
      dataIndex: "Name",
      field: "name",
      render: (text, record) => (
        <>
          <Link to={`/AssignEmployeeView/${text.id?text.id:text._id}`} className="text">
            <Tooltip title="View">
              <span className="text text-capitalize text-link d-inline m-0">
                {text.name}
              </span>
            </Tooltip>
          </Link>
        </>
      ),
    },

    {
      title: "Assign to",
      dataIndex: "members",
      field: "members",
      render: (text, record) => (
        <>
          {text && text.members.length
            ? text.members.map((res,index) => {
                return (
                  <>
                    <span className="text-capitalize">{res.fullName}{index !== text.members.length - 1 && ', '}</span>
                  </>
                );
              })
            : "--"}
        </>
      ),
    },
    {
      title: "Start date",
      dataIndex: "startDate",
      field: "startDate",
      render: (text, record) => (
        <>{moment(text && text.startDate).format("DD MMM YYYY")}</>
      ),
    },

    {
      title: "Project Status",
      dataIndex: "projectStatus",
      field: "projectStatus",
      render: (text, record) => (
        <>
           {text.projectStatus == "inProgress" ? (
            <td
              className={`text-capitalize text-${
                text.projectStatus == "inProgress"
                  ? "warning"
                  : text.projectStatus == "done"
                  ? "success"
                  : "danger"
              }`}
            >
              <p
                className={`text-capitalize btn-w btn btn-${
                  text.projectStatus == "inProgress"
                    ? "warning"
                    : text.projectStatus == "done"
                    ? "success"
                    : "danger"
                }`}
              >
                {" "}
                {text.projectStatus}{" "}
              </p>
            </td>
          ) : (
            ""
          )}
          {text.projectStatus == "onhold" ? (
            <td
              className={`text-capitalize text-${
                text.projectStatus == "onhold"
                  ? "warning"
                  : text.projectStatus == "done"
                  ? "success"
                  : "danger"
              }`}
            >
              <p
                className={`text-capitalize btn-w btn btn-${
                  text.projectStatus == "onhold"
                    ? "warning"
                    : text.projectStatus == "done"
                    ? "success"
                    : "danger"
                }`}
              >
                {" "}
                {text.projectStatus}{" "}
              </p>
            </td>
          ) : (
            ""
          )}
          {text.projectStatus == "completed" ? (
            <td
              className={`text-capitalize text-${
                text.projectStatus == "completed"
                  ? "warning"
                  : text.projectStatus == "done"
                  ? "success"
                  : "danger"
              }`}
            >
              <p
                className={`text-capitalize btn btn-w btn-${
                  text.projectStatus == "completed"
                    ? "warning"
                    : text.projectStatus == "done"
                    ? "success"
                    : "danger"
                }`}
              >
                {" "}
                {text.projectStatus}{" "}
              </p>
            </td>
          ) : (
            ""
          )}
        </>
      ),
    },
  ];




  const newlyAddedChapter =
    array && array.length
      ? array.map((items) => {
          localStorage.setItem("rolesid", items.id);
          return {
            ...items,
          };
        })
      : [];

  const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };

  const openModel = () => {
    setReason(true);
  };
  const [form] = Form.useForm();
  return (
    <Layout>
      <div>
        <div className="main-content">
          <div className="section table table-striped">
            <div className="d-flex align-items-center justify-content-between headings">
              <SectionHeader title="Assign Projects" />
              <Tooltip title="Add Projects">
                <p
                  onClick={() => openModel()}
                  className="pointer text-white  fs-3"
                >
                  <PlusSquareOutlined />
                </p>
              </Tooltip>
            </div>
            <Spin spinning={loading}>
              <MaterialTable
                options={{
                  showTitle: false,
                  pageSize: 10,
                  pageSizeOptions: [10, 20, 30, 40, 50],
                  emptyRowsWhenPaging: false,
                }}
                columns={columns}
                data={newlyAddedChapter}
                icons={tableIcons}
              />
            </Spin>
          </div>
        </div>
      </div>
      {reason ? (
        <div class="modal d-block scroll_fade">
          <div class="modal-dialog">
            <div class="modal-content border-0 p-3 rounded-0 bg_congoratulations">
              <div class="mb-2 textend_modal d-flex">
                <h5>
                  Assign Project
                </h5>
                <button
                  type="button"
                  class="btn-close ms-auto"
                  onClick={() => setReasonModal(false)}
                ></button>
              </div>
              {/* <h1>hello</h1> */}
              <Form
                name="normal_login"
                className="login-form"
                initialValues={{ remember: true }}
                onFinish={handleSubmit}
                form={form}
              >
                <div className="row">
                  <div span={12} className=" assingproject col-sm-12 mx-0 mt-2">
                    <Form.Item
                      name="project"
                      rules={[
                        {
                          required: true,
                          message: "Please Select Project!",
                        },
                      ]}
                    >
                      <Select
                        style={{ width: "100%" }}
                        showSearch={true}
                        placeholder="Select Project..."
                        onChange={handleChange1}
                        className="mb-2"
                      >
                        {projects &&
                          projects.map((item) => (
                            <Option key={[item.id, item.name]}>
                              {item.name}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                    
                    <Form.Item
                      name="member"
                      rules={[
                        {
                          required: memberarray?.length > 0 ? false: true,
                          message: "Please Select your Employees",
                        },
                      ]}
                    >
                      <Select
                        mode="multiple"
                        showSearch={true}
                        isSearchable={true}
                        value={memberarray}
                        style={{ width: "100%" }}
                        placeholder="Select Employee"
                        key={String(memberarray)}
                        defaultValue={memberarray?.length > 0 ?memberarray:null}
                        onChange={employeechange}
                      >
                        {arrayTeam &&
                          arrayTeam.map((item) => (
                            <Option key={[item.id, item.fullName]}>
                              {item.fullName}
                              {`     (${item.designation})`}
                            </Option>
                          ))}
                      </Select>
                    </Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="login-form-button mt-4style mt-3 "
                    >
                      Submit
                    </Button>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </Layout>
  );
};

export default EmployeeAssigned;
